<template>
  <div class="max-w-4xl mx-auto">
    <div class="bg-white rounded-lg shadow-md p-8">
      <div class="space-y-6">
        <div class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
          <div class="space-y-4">
            <div class="flex justify-center">
              <svg class="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
              </svg>
            </div>
            <div class="space-y-2">
              <h3 class="text-lg font-semibold text-gray-900">
                Upload Single Skyn Biosensor Data File
              </h3>
              <p class="text-sm text-gray-500">
                This public demo uses a prepared single-file example.
              </p>
            </div>
            <div class="flex justify-center">
              <button
                type="button"
                class="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                @click="showTestDataModal = true"
              >
                Upload File
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <BaseModal
      :isVisible="showTestDataModal"
      title="Upload test data"
      width="md"
      @close="showTestDataModal = false"
      @confirm="confirmTestDataUpload"
    >
      <template #content>
        <p class="text-sm text-gray-700">
          Test data will be uploaded (subid = 999, dataset_id = 123).
        </p>
        <p class="text-sm text-gray-500 mt-2">
          The file is already processed. A short progress bar will run, then the single-file results will open.
        </p>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from '../../components/BaseModal.vue'
import { demoPath } from '../../demo/paths.js'
import { buildDemoConfiguredData, clearDemoResults } from '../../demo/session.js'

export default {
  name: 'DemoUpload',
  components: { BaseModal },
  inject: ['updateGlobalState', 'setBackButton', 'hideBackButton'],
  data() {
    return {
      showTestDataModal: false,
      confirming: false
    }
  },
  mounted() {
    this.hideBackButton()
  },
  methods: {
    async confirmTestDataUpload() {
      if (this.confirming) return
      this.confirming = true
      try {
        clearDemoResults()
        const configured = await buildDemoConfiguredData()
        sessionStorage.setItem('configuredData', JSON.stringify(configured))
        this.updateGlobalState({
          configuredData: configured,
          processingResults: null,
          subid: configured.subid,
          datasetId: configured.dataset_id,
          sessionId: configured.session_id
        })
        this.showTestDataModal = false
        this.$router.push(demoPath('/dashboard'))
      } catch (error) {
        console.error('Failed to start demo upload:', error)
        this.confirming = false
      }
    }
  }
}
</script>
